'use client';

import { useTranslation } from 'next-i18next';
import { PlusIcon } from '@/icons';
import { Button, IconButton } from '@/ui_v3';
export const AddButton = ({
  isSimple,
  onClick
}: {
  isSimple: boolean;
  onClick: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  if (isSimple) {
    return <IconButton variant={'outlined'} intent="alternative" className="shrink-0" size="xs" onClick={onClick}>
        <PlusIcon size="xs" />
      </IconButton>;
  }
  return <Button variant={'outlined'} intent="alternative" size="xs" className="shrink-0" leftSlot={<PlusIcon size="xs" />} onClick={onClick} data-sentry-element="Button" data-sentry-component="AddButton" data-sentry-source-file="AddButton.tsx">
      {t('build:build.standard.action.add')}
    </Button>;
};